const map = {
	"./ar.js": 1090,
	"./de.js": 5598,
	"./en.js": 4578,
	"./es.js": 2421,
	"./fr.js": 9565,
	"./hi.js": 1582,
	"./it.js": 2652,
	"./ja.js": 6056,
	"./ko.js": 3107,
	"./pt.js": 1121,
	"./ru.js": 1548,
	"./ta.js": 2354,
	"./zh.js": 4759
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3022;